import ManualBreadcrumb from '../../components/manual/ManualBreadcrumb';
import ManualSection from '../../components/manual/ManualSection';
import ManualStep from '../../components/manual/ManualStep';
import ManualAlert from '../../components/manual/ManualAlert';

function ManualMinhaContaPage() {
  return (
    <div className="manual-page">
      <ManualBreadcrumb items={[{ label: 'Minha Conta' }]} />

      <div className="manual-header">
        <h1 className="manual-title">
          <i className="bi bi-person-circle me-3"></i>
          Minha Conta
        </h1>
        <p className="manual-subtitle">
          Consulte seus dados pessoais e gerencie segurança de acesso
        </p>
      </div>

      <ManualSection icon="bi-person-vcard" title="Informações da Conta">
        <p>
          A tela <strong>Minha Conta</strong> apresenta seus dados de usuário, órgão de vínculo,
          perfil de acesso e data de cadastro no sistema.
        </p>
      </ManualSection>

      <ManualSection icon="bi-shield-lock" title="Alteração de Senha">
        <ManualStep number="1" title="Acesse o menu do usuário">
          Clique no seu nome no canto superior direito e selecione <strong>"Minha Conta"</strong>.
        </ManualStep>

        <ManualStep number="2" title="Preencha os campos de senha">
          Informe a senha atual, a nova senha e a confirmação.
        </ManualStep>

        <ManualStep number="3" title="Salve a alteração">
          Clique em <strong>"Alterar Senha"</strong>. A validação é feita imediatamente.
        </ManualStep>

        <ManualAlert type="tip">
          A senha deve ter no mínimo 8 caracteres e combinar letras e números.
        </ManualAlert>
      </ManualSection>

      <ManualSection icon="bi-key" title="Usuário LDAP x Usuário Externo">
        <ManualAlert type="info">
          <strong>Usuário LDAP (rede interna):</strong> não altera senha por esta tela.
          A senha é gerenciada na infraestrutura corporativa.
        </ManualAlert>

        <ManualAlert type="info">
          <strong>Usuário externo (e-mail/senha):</strong> pode alterar senha em Minha Conta
          e também usar recuperação de senha pela tela de login.
        </ManualAlert>
      </ManualSection>
    </div>
  );
}

export default ManualMinhaContaPage;
